export default "__VITE_ASSET__48fccf38__"